type Props = {
  className?: string
}

export default function IconExternal({ className }: Props) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 124 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M103.82,92.29c-2.46,0-4.46,1.98-4.5,4.43-.38,1.02-3.49,2.87-5.75,2.87H27.47c-1.54,0-2.79-1.25-2.79-2.79V27.21c0-1.54,1.25-2.79,2.79-2.79,2.49,0,4.5-2.01,4.5-4.5s-2.01-4.5-4.5-4.5h-1.29c-.71,0-1.39.17-1.99.46-4.92,1.42-8.52,5.96-8.52,11.33v69.59c0,6.5,5.29,11.79,11.79,11.79h66.11c2.89,0,6.27-1.06,9.05-2.83,3.29-2.11,5.26-4.88,5.63-7.92.04-.25.06-.5.06-.76v-.28h0v-.04h0v-.02h0c-.03-2.46-2.03-4.44-4.5-4.44Z"
      />
      <path
        fill="currentColor"
        d="M103.82,15.41h-36.94c-2.49,0-4.5,2.01-4.5,4.5s2.01,4.5,4.5,4.5h26.07l-53.02,53.02c-1.76,1.76-1.76,4.61,0,6.36.88.88,2.03,1.32,3.18,1.32s2.3-.44,3.18-1.32l53.02-53.02v26.07c0,2.49,2.01,4.5,4.5,4.5s4.5-2.01,4.5-4.5V19.91c0-2.49-2.01-4.5-4.5-4.5Z"
      />
    </svg>
  )
}
